import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {ButtonToolbar,DropdownButton,Dropdown} from 'react-bootstrap';



const containerStyle: React.CSSProperties = {
    height:'75px',
    width:'100%',
    textAlign:'center'
};
const navItemStyle: React.CSSProperties = {
    fontFamily:'BarlowMedium',
    marginRight:'40px',
    cursor:'pointer',
    color:'#3a54b4',
    ':hover':{
        color:'#c2b186'
    }
}
const navBar: React.CSSProperties = {
    display:'flex',
    alignSelf:'center',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent:'center',
    flexGrow:2
}
const topNav: React.CSSProperties = {
    width:'100%',
    backgroundColor:'white',
    height:'75px',
    display:'flex',
    flexDirection:'row',
    position:'fixed',
    zIndex:2,
    border:'1px solid #e9e6e6'
}
const topNavStyle: React.CSSProperties = {
    width:'131px',
    height:'40px',
    backgroundColor:'#3a54b4',
    margin:'13px 10px',
    lineHeight:'38px',
    padding:'5px',
    fontFamily:'BarlowMedium',
    cursor:'pointer',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    color:'white'
}
const loggedIn : React.CSSProperties = {
    position:'absolute',
    right:'10%',
    top:'50px',
    fontFamily:'BarlowLight'
}

const hamburgerStyle: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl("~/images/hamburger_2.png") + ')',
    height: '50px',
    width: '50px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0
};

const dropdownItemStyle: React.CSSProperties = {
    display: 'block',
    padding: '10px 15px',
    fontFamily: 'BarlowMedium',
    fontSize: '16px',
    borderBottom: '1px solid #eee',
    textTransform: 'uppercase',
    color: '#333'
};


const imgFile = Tgcc.ResolveUrl('~/images/2022Logo.png');

const imgStyles : React.CSSProperties ={
    cursor:'pointer',
    width:'75px',
    height:'75px',
};
const txt: React.CSSProperties = {
    fontFamily:"BarlowMedium",
    marginLeft:'20px',
}
const logoTxt: React.CSSProperties = {
    marginLeft:'40px',
    display:'flex',
    alignItems:'center',
    flexGrow:1
}
const rightNav: React.CSSProperties = {
    display:'flex',
}
const GCText: React.CSSProperties = {
    fontFamily:"BarlowMedium",
}
const emailStyle: React.CSSProperties = {
    fontFamily:'BarlowMedium'
}
const mobileNav: React.CSSProperties = {
    display:'flex'
}
const hamburger: React.CSSProperties = {
    backgroundImage:'url('+ Tgcc.ResolveUrl("~/images/hamburger_2.png"),
    height:'50px',
    width:'50px',
    backgroundPosition:'center',
    backgroundSize:'cover',
}

const topLoginStyle = Object.assign({}, topNavStyle, {margin: '13px 10px 20px'});

class _MajorAccountsHdr extends React.Component < Tgcc.BaseProps, any > {
    openDashboard = () => {browserHistory.push(Tgcc.Routes.DashBoard)};
    openCSR = () => {browserHistory.push(Tgcc.Routes.CSR)};
    openDesign = () => {browserHistory.push(Tgcc.Routes.MajorAccountsDesignListView)};
    openHome = () => {browserHistory.push(Tgcc.Routes.Home)};
    openContact = () => {browserHistory.push(Tgcc.Routes.Contact)}

   
    openProducts = () => {browserHistory.push(Tgcc.Routes.ProductCategoryListView)};
    openRegister = () =>{browserHistory.push(Tgcc.Routes.Register)}
    loginUser = () => {
        browserHistory.push(Tgcc.Routes.Login)
    }

    logoutUser = () => {
        Tgcc.LogoutUser(this.props.dispatch, this.props.state.LoginData);
        this.props.dispatch({type:Tgcc.StateAction.ForwardLocation, payload:this.props.state.ActiveProof});
    }

    getLoginLink(){
        if(this.props.state.LoginData){
            return <div style={topLoginStyle} className="logStyle" key={1} onClick={this.logoutUser}>Logout</div>
        }
        return <div  style={topLoginStyle} className="logStyle" key={2} onClick={this.loginUser}>Login</div>
    }
    getDashboardLink(){
        if(!this.props.state.LoginData){
            return <div style={topNavStyle} key={3} className="acctStyle" onClick={this.openRegister}>Create Account</div>
        }
        return <div style={topNavStyle} key={4} className="acctStyle" onClick={this.openDashboard}>Dashboard</div>
    }
    getUserName(){
        if(this.props.state.LoginData && this.props.state.LoginData.impersonate)
            return <div style={loggedIn}>Impersonating: {this.props.state.LoginData.impersonate}</div>
            
        if(this.props.state.UserInfo && this.props.state.UserInfo.email)
            return <div style={loggedIn} className='maloggedStyle'>Logged in as: <span style={emailStyle}>{this.props.state.UserInfo.email}</span></div>
    }
    openProofEdit = () => {
        if(this.props.state.LoginData && this.props.state.UserInfo){
            browserHistory.push(Tgcc.Routes.ProofEdit)
        }
        else {
            browserHistory.push(Tgcc.Routes.Register)
        }    
    };
    getMobile() {
        var logLink = this.getLoginLink();
        var dbLink = this.getDashboardLink();
        if (window.innerWidth <= 440) {
            return (
                <div style={mobileNav}>
                    <Dropdown>
                        <Dropdown.Toggle id="mobile-dropdown" style={hamburgerStyle} variant="light" />
                        <Dropdown.Menu>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="101" onClick={this.openHome}>HOME</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="102" onClick={this.openDesign}>DESIGNS</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="103" onClick={this.openProofEdit}>GET STARTED</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="104" onClick={this.openProducts}>PRODUCTS</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div style={mobileNav} className='campuMobileLink'>
                        {logLink}
                        {dbLink}
                    </div>
                    {this.getUserName()}
                </div>
            );
        } else {
            return(
                <div style={topNav} className="maTopNav">
                <div onClick={this.openHome} style={logoTxt} className="campusNvLogo">
                            <img src={imgFile} style={imgStyles}/>
                    </div>
                <div style={navBar} className="newCampusNv">
                    <div key={99}  style={navItemStyle}  onClick={this.openHome}>HOME</div>
                    <div key={96}  style={navItemStyle}  onClick={this.openDesign}>DESIGNS</div>
                   <div key={97}  style={navItemStyle}  onClick={this.openProofEdit}>GET STARTED</div>
                   <div key={95}  style={navItemStyle}  onClick={this.openProducts}>PRODUCTS</div>
                </div>
                <div style={rightNav} className="logNav">
                    {logLink}
                    {dbLink}
                </div>
                {this.getUserName()}
                
                </div>            
              
            )
        }
    }
    render() {
        var navbar = this.getMobile();
        return (
            <div style={containerStyle} className="majorHdrDiv">
                {navbar}
              
            </div>
        )

    }
    
}
const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        state: state
    };
};

export var MajorAccountsHdr = connect(mapStateToProps)(Radium(_MajorAccountsHdr));